import { defineMessages } from 'react-intl'

export default defineMessages({
  renotifyClient: {
    id: 'containers.OrderPage.components.TaskPage.components.ActionsMenuFragments.renotifyClient',
    defaultMessage: 'Renotify client',
  },
  renotifyClientConfirm: {
    id: 'containers.OrderPage.components.TaskPage.components.ActionsMenuFragments.renotifyClientConfirm',
    defaultMessage: 'Are you sure this is what you want?\n\nCustomer will be notified again, and files will be deployed again, if automatic deployment is setup for the customer.',
  },
  renotifyClientSuccess: {
    id: 'containers.OrderPage.components.TaskPage.components.ActionsMenuFragments.renotifyClientSuccess',
    defaultMessage: 'Renotified customer',
  },
  renotifyClientError: {
    id: 'containers.OrderPage.components.TaskPage.components.ActionsMenuFragments.renotifyClientError',
    defaultMessage: 'Error notifying customer',
  },
})
